import { Spin } from 'antd';
import { lazy, Suspense } from 'react';

// Loaded on demand: the agent brings in the Anthropic SDK, the ops-mcp tools
// and a Markdown renderer that no other page needs.
const AgentChatPage = lazy(() =>
  import('apps/agent/pages').then(m => ({ default: m.AgentChatPage }))
);
const AgentActivityPage = lazy(() =>
  import('apps/agent/ActivityPage').then(m => ({ default: m.AgentActivityPage }))
);
const AgentApprovalsPage = lazy(() =>
  import('apps/agent/ApprovalsPage').then(m => ({ default: m.AgentApprovalsPage }))
);

// One route for /agent (new chat) and /agent/t/:threadId, so the page stays
// mounted when a new chat gets its thread URL mid-run.
const agentRoutes = [
  {
    path: '/agent/activity',
    element: (
      <Suspense fallback={<Spin style={{ margin: 48 }} />}>
        <AgentActivityPage />
      </Suspense>
    ),
  },
  {
    path: '/agent/approvals',
    element: (
      <Suspense fallback={<Spin style={{ margin: 48 }} />}>
        <AgentApprovalsPage />
      </Suspense>
    ),
  },
  {
    path: '/agent/*',
    element: (
      <Suspense fallback={<Spin style={{ margin: 48 }} />}>
        <AgentChatPage />
      </Suspense>
    ),
  },
];

export default agentRoutes;
